'use client';

import { useMemo } from 'react';
import Image from 'next/image';
import { useParams } from 'next/navigation';
import { useTranslation } from 'react-i18next';
import { LangLink } from '../../../i18n/links';
import { defaultLang, SUPPORTED } from '../../../config/languages';
import { solutions } from '../solutions/solutions';

export default function SolutionsLayout2() {
  const { lang = defaultLang } = useParams();
  const activeLang = SUPPORTED.includes(lang) ? lang : defaultLang;
  const { t } = useTranslation('solutions');

  const items = useMemo(() => solutions.map((solution) => {
    const translation = solution.translations?.[activeLang] || solution.translations?.en || solution;
    return {
      ...solution,
      title: translation.title || solution.title,
      description: translation.description || solution.description,
      slug: typeof solution.slug === 'object'
        ? (solution.slug[activeLang] || solution.slug.en)
        : solution.slug,
    };
  }), [activeLang]);

  return (
    <>
      <link rel="stylesheet" href="/assets/css/blog-layout-2.css" />
      <link rel="stylesheet" href="/assets/css/solutions-layout-2.css" />
      <main className="blog-v2-page solutions-v2-page">
        <section className="solutions-v2-hero">
          <div className="container blog-v2-container">
            <p className="blog-v2-eyebrow">{t('otherIndustries')}</p>
            <h1>{t('title')}</h1>
            <p className="solutions-v2-intro">{t('subtitle')}</p>
          </div>
        </section>

        <section className="solutions-v2-grid-section" aria-labelledby="solutions-v2-title">
          <div className="container blog-v2-container">
            <div className="solutions-v2-section-heading">
              <p className="blog-v2-eyebrow">AdCast</p>
              <h2 id="solutions-v2-title">{t('otherIndustries')}</h2>
            </div>
            <div className="solutions-v2-grid">
              {items.map((solution, index) => (
                <article className={`solutions-v2-card${index === 0 ? ' solutions-v2-card-featured' : ''}`} key={solution.id}>
                  <LangLink to={`/solutions/${solution.slug}`} className="solutions-v2-card-image" aria-label={solution.title}>
                    <Image
                      src={solution.image}
                      alt={solution.title}
                      fill
                      sizes={index === 0 ? '(max-width: 900px) 100vw, 58vw' : '(max-width: 900px) 100vw, 32vw'}
                    />
                  </LangLink>
                  <div className="solutions-v2-card-copy">
                    <span className="solutions-v2-card-number">{String(index + 1).padStart(2, '0')}</span>
                    <h3><LangLink to={`/solutions/${solution.slug}`}>{solution.title}</LangLink></h3>
                    <p>{solution.description}</p>
                    <LangLink to={`/solutions/${solution.slug}`} className="solutions-v2-read-more">
                      {t('readMore')} <span aria-hidden="true">→</span>
                    </LangLink>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>
      </main>
    </>
  );
}
